import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BurialLayoutType } from 'src/app/enums/burial-layout-type';
import { RestApiEndpoints } from 'src/app/enums/rest-api-endpoints';
import { CredentialsService } from 'src/app/services/credentials.service';
import { RestApiService } from 'src/app/services/rest-api.service';
import { ServiceWorkerService } from 'src/app/services/service-worker.service';
import { hidePartnerfriedhoefeNav, hideTipsNav } from 'src/app/config/ui-flags';

declare function initSideNav(): void;
declare function initNavMenuMoreDropDown(): void;
declare function makeToast(message: string): void;
declare function isValidStr(string: string): boolean;
declare function openModalWithID(modalID: string): void;

@Component({
  selector: 'app-dash',
  templateUrl: './dash.component.html',
  styleUrls: ['./dash.component.css']
})
export class DashComponent {

  burialLayoutType: BurialLayoutType = this.credentialsService.burialLayoutType;

  // Old SearchController
  search: string = '';
  payload = {};
  isSearchLoading: boolean = false;
  msg: string = '';
  success: boolean = false;
  result = [];
  // Old SearchController


  currentLocationName: string = 'Aktueller Standort';
  hideDocsAndCemetery: boolean = false;
  /** Entspricht ui-flags.hideTipsNav; bei false Tipps wieder sichtbar. */
  hideTips: boolean = hideTipsNav;
  /** Entspricht ui-flags.hidePartnerfriedhoefeNav. */
  hidePartnerfriedhoefeNav: boolean = hidePartnerfriedhoefeNav;

  constructor(private credentialsService: CredentialsService,
    private restApiService: RestApiService,
    private location: Location,
    private router: Router,
    private serviceWorkerService: ServiceWorkerService) {

      const userName = localStorage.getItem('userName');
      if (userName && userName.length > 0) {
          this.currentLocationName = userName;
      }

      // Kunden ohne Dokumenten- und Friedhofbereich
      const locationsWithoutDocsAndCemetery = ['Krematorium-am-Limes'];
      this.hideDocsAndCemetery = locationsWithoutDocsAndCemetery.includes(this.currentLocationName);
      
    if (location.isCurrentPathEqualTo("/dash")) {
      router.navigate(['/dash/burials']);
    }

  }

  ngAfterViewInit() {
    initSideNav();
    initNavMenuMoreDropDown();

    if (this.credentialsService.checkAuthentication()) {
      //this.serviceWorkerService.requestPushSubscription(); // TODO: Activate this when push notifications get started 
    }
  }

  printAllInvoicesButtonClicked() {
    const url = this.router.serializeUrl(this.router.createUrlTree([`documents/all`]));
    window.open(url, '_blank');
  }

  // Old SearchController
  openSearch() {
    openModalWithID('searchModal');
    this.resetSearch();
  }

  requestSearch() {
    if (!isValidStr(this.search)) { return; }

    this.isSearchLoading = true;

    this.payload = {
      searchTerm: this.search
    };

    this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.searchDocs, this.payload, (success, response) => {
      this.isSearchLoading = false;

      if (!response || !response.message) { return; }

      if (!success) {
        this.msg = response.message;
        makeToast(this.msg);
        this.success = false;
        return;
      }

      this.msg = response.message;
      makeToast(this.msg);

      if (!response.payload.docs || response.payload.docs.length == 0) { return; }

      this.result = response.payload.docs;
      this.success = true;
    });
  }

  resetSearch() {
    this.search = '';
    this.payload = {};
    this.isSearchLoading = false;
    this.msg = '';
    this.success = false;
    this.result = [];
  }
  // Old SearchController

}
